module.exports = __webpack_public_path__ + "assets/img/breadcrumb-shape.bae27a07.png";